export const hasReportSelection = (selection) =>
  selection?.mode === 'exclude' ||
  (selection?.mode === 'all' && selection.explicit === true) ||
  (selection?.mode === 'custom' && selection.values?.length > 0)

export const serializeReportSelection = (selection) => {
  if (selection?.mode === 'exclude') return { mode: 'exclude', values: selection.values || [] }
  if (selection?.mode === 'custom') return { mode: 'include', values: selection.values || [] }
  return 'all'
}

export const cloneFilterSelection = (selection) => ({
  mode: selection?.mode || 'all',
  values: [...(selection?.values || [])],
  ...(selection?.explicit ? { explicit: true } : {})
})

export const toggleReportSelection = (selection, value) => {
  const values = selection?.values || []
  const next = values.includes(value) ? values.filter((item) => item !== value) : [...values, value]
  if (selection?.mode === 'exclude' || (selection?.mode === 'all' && selection.explicit)) {
    return next.length
      ? { mode: 'exclude', values: next }
      : { mode: 'all', values: [], explicit: true }
  }
  return { mode: next.length ? 'custom' : 'all', values: next }
}
